import { AnyObject } from "../@types/base.types";

export const useDataAttributes = (props: AnyObject) => {
  const result = {} as AnyObject;
  Object.entries(props).forEach(e => {
    if (e[0].match(/^data-/)) result[e[0]] = e[1];
  })
  return result
}